/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function r(r){return r?.map?.allLayers?.toArray().filter(r=>("graphics"!==r.type||!r.internal)&&r.visible).map(r=>r.uid)??[]}export{r as getVisibleLayerIds};
